import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BUY_TICKETS, API_SUBMIT_INVESTMENT } from "../../../config/api";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const buyHWSTickets = createAsyncThunk(
  "hws/buyHWSTickets",
  async ({ data, name, failed, cb }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_BUY_TICKETS,
        data: data,
      });

      cb();

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();

      return rejectWithValue(
        error.response?.data || "An unexpected error occurred"
      );
    }
  }
);
